import React from 'react';
import { Link } from 'react-router-dom';
import { DashboardStudySite } from '@/hooks/useDashboardStudySites';
import { getEntityStatusInfo } from '@/utils/entityStatuses';

interface SiteCardProps {
  site: DashboardStudySite;
}

export const SiteCard: React.FC<SiteCardProps> = ({ site }) => {
  const status = site.status ?? '';
  const { color: statusColor, label: statusLabel } =
    getEntityStatusInfo(status);

  return (
    <Link
      to={`/sites/${site.id}`}
      className="block bg-white border border-gray-200 rounded-[10px] p-5 flex-shrink-0 hover:border-gray-300 hover:shadow-sm transition-all"
      style={{
        width: 'calc((100vw - 12rem) / 3)',
        minWidth: '300px',
        maxWidth: '400px',
      }}
    >
      <h3 className="text-base text-[#101828] mb-4">{site.site_name ?? '—'}</h3>
      <div className="grid grid-cols-2 gap-x-4 gap-y-3 text-sm">
        <div>
          <p className="text-xs text-gray-400 mb-0.5">Protocol #</p>
          <p className="text-gray-900">{site.protocol_number ?? '—'}</p>
        </div>
        <div>
          <p className="text-xs text-gray-400 mb-0.5">Submission ID</p>
          <p className="text-gray-900">{site.display_id ?? '—'}</p>
        </div>
        <div>
          <p className="text-xs text-gray-400 mb-0.5">PI Name</p>
          <p className="text-gray-900">{site.pi_name ?? '—'}</p>
        </div>
        <div>
          <p className="text-xs text-gray-400 mb-0.5">Status</p>
          {status ? (
            <div className="flex items-center gap-1.5">
              <span
                className="w-2 h-2 rounded-full flex-shrink-0"
                style={{ backgroundColor: statusColor }}
              />
              <p className="text-gray-900">{statusLabel}</p>
            </div>
          ) : (
            <p className="text-gray-900">—</p>
          )}
        </div>
      </div>
    </Link>
  );
};
